export default {"src":"/_next/static/media/accuracy_grey.1d59dc4e.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};